// @ts-nocheck
/* eslint-enable */
/* eslint-disable react/no-multi-comp */
// App
import React from 'react';

// Misc / utils
import * as S from './styles';

const SLIDER_LEGEND = {
  0: 'Any',
  1: '1 hour',
  2: '45 min',
  3: '30 min',
  4: '<15 min',
};
const CommuteSlider = ({ handleSliderSelection, currentValue }) => {
  const Thumb = (props) => <S.SliderThumb {...props}>{'| |'}</S.SliderThumb>;
  const Track = (props, state) => <S.SliderTrack {...props} index={state.index} />;
  const Marks = (props) => {
    const currentKey = props.key;

    // This is only to get the labels underneath the slider to line up
    if (currentKey >= 1) {
      const currentPos = props.style.left;
      const newPos = currentPos - 10;

      props.style = {
        ...props.style,
        left: `${newPos}px`,
        width: '50px',
      };
    }

    return <S.SliderMarks {...props}>{SLIDER_LEGEND[currentKey]}</S.SliderMarks>;
  };

  const handleChange = (val) => {
    handleSliderSelection(val);
  };

  return (
    <S.CommuteSlider
      ariaLabel={'Desired maximum commute time'}
      ariaValuetext={(state) => `Selected maximum commute time ${SLIDER_LEGEND[state.valueNow]}`}
      marks
      min={0}
      max={4}
      value={currentValue}
      renderMark={Marks}
      renderThumb={Thumb}
      renderTrack={Track}
      onAfterChange={handleChange}
    />
  );
};

export default CommuteSlider;
